<div class="restore-orders-container">
  <div class="restore-orders-container__header">
    <div class="restore-orders-container__header-title">Restore orders?</div>
    <div class="close-icon">
      <img alt="" (click)="onCancel()" src="../.././../../../assets/icons/x-delivery-services.svg" />
    </div>
  </div>
  <div class="text">
    <div class="restore-orders-container__text">
      Restore {{count > 1 ? count + ' these orders' : ' this order' }} and move them back to the Verify panel?
    </div>
  </div>

  <div class="restore-orders-container__actions">
    <pdq-button (onClick)="onRestoreClick()" [label]="'Restore'" [variant]="'primary'"> </pdq-button>

    <pdq-button (onClick)="onCancel()" [label]="'Cancel'" [variant]="'light'"> </pdq-button>
  </div>
</div>
